<template>
<div
    style="margin-bottom: 15px;"
    v-if="visible"
>
    <b>{{text}}</b><br/>

    <a
        :href="value"
        target="_blank"
        v-if="link_out"
    >
        {{value}}
    </a>

    <span
        v-else
    >
        {{value}}
    </span>
</div>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            default: function() { return ""; }
        },

        hide_empty: {
            type: Boolean,
            default: function() { return false; }
        },

        value: {
            type: [String, Number],
            default: function() { return ""; }
        },

        link_out: {
            type: Boolean,
            default: function() { return false; }
        }
    },

    computed: {
        visible() {
            if ( !this.hide_empty ) return true;

            if ( this.value == null ) return false;
            if ( (''+this.value).trim().length == 0 ) return false;

            return true;
        }
    },
}
</script>

<style lang="scss" scoped>

</style>